/* @flow strict */

import queryString from 'query-string';
import * as React from 'react';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { Link } from 'react-router-dom';
import { POST, PUT } from '/client/src/api';
import { validateInput } from '/client/src/utils/validateInput';


type PropsType = {
  location: {
    search: any
  }
};

const Reset = (props: PropsType): React.Element<typeof React.Fragment> => {
  const values = queryString.parse(props.location.search);
  const _email = values.email;
  const _code = values.code;
  const isConfirm = _.size(_email) && _.size(_code);
  const [ email, setEmail ] = React.useState('');
  const [ pass, setPass ] = React.useState('');
  const [ confirm_pass, setConfirmPass] = React.useState('');
  const [isSendRequest, sendResetRequest] = React.useState(false);
  const [isSendRequestResetConfirm, sendRequestResetConfirmStatus] = React.useState(false);
  const [errorResetConfirm, setErrorResetConfirm] = React.useState(false);

  const emailValidationMessage = React.createRef();
  const passValidationMessage = React.createRef(); 
  const confirmPassValidationMessage = React.createRef();

  const sendRequest = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    const isValid = validateInput(emailValidationMessage.current, email);

    if (isValid) {
      try {
        setStatus('loading');

        await POST('/api/v1/1/account/send_reset_email', {
          email_address: email,
          is_app : true
        });

        setStatus('success');
        sendResetRequest(true);
      } catch (error) {
        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    }
  };

  const sendRequestResetConfirm = async (e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void): Promise<any> => {
    e.preventDefault();

    const isValidPass = validateInput(passValidationMessage.current, pass);
    const isValidConfPass = validateInput(confirmPassValidationMessage.current, confirm_pass);
    const isPasswordsMatch = validateInput(passValidationMessage.current, pass, confirmPassValidationMessage.current, confirm_pass, ); 

    if (isValidPass && isValidConfPass && isPasswordsMatch) {
      try {
        setStatus('loading');

        const { success } = await PUT('/api/v1/1/account/reset_password', {
          email_address: _email,
          password: pass,
          password_reset_code: _code
        });

        setStatus('success');
        sendRequestResetConfirmStatus(true);
      } catch (error) {
        setStatus('error');
        setErrorResetConfirm(_.get(error, 'data.error.message', 'Error'));
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, 5000);
      }
    }
  };

  return (
    <>
      <div className="form-box-container">
        {errorResetConfirm &&
          <div className="alert alert-danger mt-3">
            <div data-bind="text: errorMessage">
            {errorResetConfirm}
          </div>
        </div>
        }
        <div className="form-box-message">
          <h3 className="auth-message-header">
            {!!isConfirm &&
              <>
                {isSendRequestResetConfirm ?
                  'Password was successfully changed' :
                  'Set a new password'
                }
              </>
            }
            {!isConfirm &&
              <>
                {isSendRequest ?
                  'Check your email' :
                  'Reset your password'
                }
              </>
            }
          </h3>
          <div
            className="auth-message-desc"
          >
            {!!isConfirm &&
              <>
                {isSendRequestResetConfirm ?
                  <>To enter the application please <Link to='/login'>Log In.</Link></> :
                  <>Enter a new password below. Then click Reset Password to set a new password for <b>{_email}</b> and login.</>
                }
              </>
            }

            {!isConfirm &&
              <>
                {isSendRequest ?
                  'A reset link was sent to:' :
                  'Enter your email below and we will send you a link to reset your password.'
                }
              </>
            }
          </div>
        </div>

        {!!isConfirm && !isSendRequestResetConfirm &&
          <form role='form'>
            <div className="mt-4 form-group">
              <label htmlFor="password">New Password</label>
              <div ref={passValidationMessage}>
                <div className="input-group">
                <input
                  className="js_password_check form-control validationElement"
                  type="password"
                  title="This field is required."
                  id="password"
                  value={pass}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    passValidationMessage.current.classList.remove('has-error');
                    passValidationMessage.current
                      .querySelector('input')
                      .classList
                      .remove('validationElement');
                    setPass(e.target.value);
                  }}
                />
                <span
                  className="input-group-addon"
                  onClick={(e: any) => {
                    const inputEl = e.currentTarget.previousSibling;
                    const icon = e.currentTarget.querySelector('i');
                    const currentType = inputEl.getAttribute('type');

                    inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                    icon.setAttribute(
                      'class',
                      currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                    );
                  }}
                >
                  <i className="glyphicon glyphicon-eye-open" />
                </span>
                </div>
                <span className="validationMessage">This field is required.</span>
              </div>
              
            </div>
            <div  className="mt-4 form-group">
              <label htmlFor="confirm_password">Confirm New Password</label>
              <div ref={confirmPassValidationMessage}>
                <div className="input-group">
                <input 
                  className="js_password_check form-control validationElement"
                  type="password"
                  title="This field is required."
                  id="confirm_password"
                  value={confirm_pass}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    confirmPassValidationMessage.current.classList.remove('has-error');
                    confirmPassValidationMessage.current
                      .querySelector('input')
                      .classList
                      .remove('validationElement');
                    setConfirmPass(e.target.value);
                  }}
                />
                <span
                  className="input-group-addon"
                  onClick={(e: any) => {
                    const inputEl = e.currentTarget.previousSibling;
                    const icon = e.currentTarget.querySelector('i');
                    const currentType = inputEl.getAttribute('type');

                    inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                    icon.setAttribute(
                      'class',
                      currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                    );
                  }}
                >
                  <i className="glyphicon glyphicon-eye-open" />
                </span>   
                </div>             
                <span className="validationMessage">This field is required.</span>
              </div>
            </div>
            <br />

            <div className="row">
              <div className="col-xs-12 text-center progress-button-50">
                <BtnLoader
                  label='Reset Password'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    sendRequestResetConfirm(e, setStatus);
                  }}
                />
              </div>
            </div>
          </form>
        }

        {!isConfirm &&
          <>
          {isSendRequest ?
          <>
            <div className="email" style={{ margin: '.75rem 0' }}><b>{email}</b></div>
            <div style={{ lineHeight: 1.5 }}>
              Follow the instructions in that email to reset your password. Check all folders in your inbox including your spam folder.
            </div>
          </> :
          <form role="form">
            <div className="mt-4">
              <label htmlFor="email">Email</label>
              <div ref={emailValidationMessage}>
                <input
                  className="form-control"
                  type="email"
                  title="This field is required."
                  value={email}
                  onChange={(e: SyntheticEvent<HTMLInputElement>) => {
                    emailValidationMessage.current.classList.remove('has-error');
                    emailValidationMessage.current
                      .querySelector('input')
                      .classList
                      .remove('validationElement');

                    emailValidationMessage.current
                       .querySelector('span.validationMessage')
                      .innerText = 'This field is required.';

                    setEmail(e.target.value);
                  }}
                />
                <span
                  className="validationMessage"
                >This field is required.</span>
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-xs-12 text-center progress-button-50">
                <BtnLoader
                  label='Reset Password'
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    sendRequest(e, setStatus);
                  }}
                />
              </div>
            </div>
          </form>
          }
          </>
        }
      </div>
    </>
  );
};

export default Reset;
